export { default } from './useScrollTrigger';